import React, { useEffect, useState } from "react";
import { TreeAPI } from "../services/api";
import { ChevronDown, ChevronRight, Workflow, Tag } from "lucide-react";

/* interface TreeNode {
  text: string;
  tag: number;
  color?: string;
  children: TreeNode[];
  wbsNo?: number;
  notationNo?: number;
} */
interface TreeNode {
  text: string;
  tag: number;
  color?: string;
  children: TreeNode[];

  wbsNo?: number;
  notationNo?: number;

  notationHead?: number;
  sequence?: number;
  front?: number;
}
interface Props {
  projectId: number;
  refresh?: number;
  onSelect?: (node: TreeNode) => void;
}

const getNodeKey = (node: TreeNode) => {
  if (node.tag === 0 && !node.wbsNo && !node.notationNo) {
    return "root";
  }

  if (node.tag > 0) {
    return `wbs-${node.wbsNo ?? node.tag}`;
  }

  return `not-${node.notationNo ?? Math.abs(node.tag)}`;
};

const getNodeColor = (node: TreeNode) => {
  return node.tag > 0 ? "text-black" : "text-[#6E8CA0]";
};

const findNodeByTag = (
  node: TreeNode,
  tag: number
): TreeNode | null => {
  if (node.tag === tag) return node;

  for (const child of node.children) {
    const found = findNodeByTag(child, tag);
    if (found) return found;
  }

  return null;
};


const findPath = (
  node: TreeNode,
  tag: number,
  path: TreeNode[] = []
): TreeNode[] | null => {
  const currentPath = [...path, node];

  if (node.tag === tag) {
    return currentPath;
  }

  for (const child of node.children) {
    const result = findPath(child, tag, currentPath);

    if (result) {
      return result;
    }
  }

  return null;
};

/* const getIcon = (isSelected: boolean, isNotation: boolean) => {
  const color = isSelected ? "text-indigo-700" : "text-indigo-500";

  if (isNotation) {
    return <Tag size={14} className="text-[#3F5F82]" />;
  }

  return <Workflow size={16} className={color} />;
}; */

interface NodeProps {
  node: TreeNode;
  level?: number;
  selectedTag: number | null;
  onSelect?: (node: TreeNode) => void;
  openNodes: Record<string, boolean>;
  setOpenNodes: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

const AccordionNode = ({
  node,
  level = 0,
  selectedTag,
  onSelect,
  openNodes,
  setOpenNodes,
}: NodeProps) => {
  const hasChildren = node.children?.length > 0;

  const isNotation = node.tag < 0;

  const isSelected = selectedTag === node.tag;

  const nodeKey = getNodeKey(node);

  const open = !!openNodes[nodeKey];

  return (
    <div style={{ paddingLeft: `${level * 10}px` }}>
      <div
        className={`flex items-center rounded-md px-1 py-0.5 cursor-pointer ${
          isSelected
            ? "bg-indigo-100 text-indigo-700"
            : "hover:bg-indigo-50"
        }`}
        onClick={() => {
          if (hasChildren) {
           /*  setOpenNodes((prev) => ({
              ...prev,
              [nodeKey]: !prev[nodeKey],
            })); */
            setOpenNodes((prev) => {
  const updated = {
    ...prev,
    [nodeKey]: !prev[nodeKey],
  };

  sessionStorage.setItem(
    "FourthTreeOpenNodes",
    JSON.stringify(updated)
  );

  return updated;
});
          }

          onSelect?.(node);
        }}
      >
        {hasChildren ? (
          <button
            className="w-4 h-4 flex items-center justify-center shrink-0"
            onClick={(e) => {
              e.stopPropagation();

             /*  setOpenNodes((prev) => ({
                ...prev,
                [nodeKey]: !prev[nodeKey],
              })); */
              setOpenNodes((prev) => {
  const updated = {
    ...prev,
    [nodeKey]: !prev[nodeKey],
  };

  sessionStorage.setItem(
    "FourthTreeOpenNodes",
    JSON.stringify(updated)
  );

  return updated;
});
            }}
          >
            {open ? (
              <ChevronDown
                size={14}
                className="text-gray-600"
              />
            ) : (
              <ChevronRight
                size={14}
                className="text-gray-600"
              />
            )}
          </button>
        ) : (
          <span className="w-4 h-4" />
        )}

        <div className="flex items-center gap-1 min-w-0">

          {/* {getIcon(isSelected, isNotation)} */}

          <span
            className={`${getNodeColor(
              node
            )} whitespace-nowrap overflow-hidden text-ellipsis`}
            style={{
              fontFamily: "'Segoe UI'",
              fontSize: "13px",
              fontWeight: 400,
            }}
          >
            {node.text}
          </span>

          <span
            className="text-gray-500"
            style={{
              fontFamily: "'Segoe UI'",
              fontSize: "13px",
              fontWeight: 400,
            }}
          >
           {/*  {node.tag > 0
              ? `WBS : ${node.wbsNo}`
              : `Notation : ${node.notationNo}`} */}
          </span>
        </div>
      </div>

      {open &&
        hasChildren &&
        node.children.map((child) => (
          <AccordionNode
            key={getNodeKey(child)}
            node={child}
            level={level + 1}
            selectedTag={selectedTag}
            onSelect={onSelect}
            openNodes={openNodes}
            setOpenNodes={setOpenNodes}
          />
        ))}
    </div>
  );
};
const FourthTree = ({
  projectId,
  refresh,
  onSelect,
}: Props) => {
  const [tree, setTree] = useState<TreeNode | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState<number | null>(null);
  const [openNodes, setOpenNodes] = useState<Record<string, boolean>>({});

 
  const loadTree = () => {
    setLoading(true);

    TreeAPI.getTree(projectId)
      .then((data) => {
        setTree(data);
      })
      .catch(() => {
        alert("Failed to load tree");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadTree();
  }, [projectId, refresh]);

  useEffect(() => {
  if (!tree) return;

  /* const rootKey = getNodeKey(tree);

  setOpenNodes({
    [rootKey]: true,
  });
 */
const rootKey = getNodeKey(tree);

setOpenNodes({
  [rootKey]: true,
});
  


  const savedTag = sessionStorage.getItem("FourthTreeSelectedTag");

if (savedTag) {
  const tag = Number(savedTag);

  const node = findNodeByTag(tree, tag);
  const path = findPath(tree, tag);

  if (node && path) {
    
    
    
   /*  const expanded: Record<string, boolean> = {};

    path.forEach((n) => {
      expanded[getNodeKey(n)] = true;
    });

    setOpenNodes(expanded);

    setSelectedTag(node.tag);

    onSelect?.(node);

    return; */
    const savedOpenNodes = sessionStorage.getItem(
  "FourthTreeOpenNodes"
);

if (savedOpenNodes) {

  setOpenNodes({
    [rootKey]: true,
    ...JSON.parse(savedOpenNodes),
  });

} else {

  const expanded: Record<string, boolean> = {};

  path.forEach((n) => {
    expanded[getNodeKey(n)] = true;
  });

  setOpenNodes(expanded);
}

setSelectedTag(node.tag);

onSelect?.(node);

return;


  }
}

  setSelectedTag(tree.tag);

  sessionStorage.setItem(
    "FourthTreeSelectedTag",
    tree.tag.toString()
  );

  onSelect?.(tree);

}, [tree]);

 /*  useEffect(() => {
    if (!tree) return;

    const rootKey = getNodeKey(tree);

    setOpenNodes({
      [rootKey]: true,
    });

    setSelectedTag(tree.tag);

    onSelect?.(tree);
  }, [tree]); */

  /* const handleSelect = (node: TreeNode) => {
     console.log("FourthTree Selected:", node);
    setSelectedTag(node.tag);
    onSelect?.(node);
  }; */


 const handleSelect = (node: TreeNode) => {
  console.log("FourthTree Selected:", node);

  setSelectedTag(node.tag);

  sessionStorage.setItem(
    "FourthTreeSelectedTag",
    node.tag.toString()
  );

  

  onSelect?.(node);
};


  if (loading) {
    return (
      <div
        style={{
          fontFamily: "'Segoe UI'",
          fontSize: "13px",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div
      className="thin-scrollbar h-full w-full overflow-y-auto bg-transparent p-1"
      style={{
        fontFamily: "'Segoe UI'",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      {tree && (
        <AccordionNode
          node={tree}
          selectedTag={selectedTag}
          onSelect={handleSelect}
          openNodes={openNodes}
          setOpenNodes={setOpenNodes}
        />
      )}
    </div>
  );
};

export default FourthTree;